(function(){
    angular
        .module('appback')
        .directive('ngCitologia121', citologia121);

        citologia121.$inject = ['ResultadosService','$timeout'];
        function citologia121(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=citologia121.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	//console.log(scope);
		            	scope.loadingFields = false;
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { extensiones : [{celulas : [] }] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { extensiones : [{celulas : [] }] }};
				            }
				        }
		            	
		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                     }

	                     scope.borrarExt = function(index){
	                     	scope.item.resultado.extra.resultado.extensiones.splice(index,1);

	                     }

	                     scope.nuevaCelula = function(ext){
	                     	//console.log(ext.celulas);
	                     	if(typeof(ext.celulas)=='undefined' || !angular.isArray(ext.celulas)){
	                     		ext.celulas = [{tipocelular:''}];
	                     	}
	                     	ext.celulas.push({tipocelular:''});
	                     }
	                     scope.borrarCelula = function(ext,index){
	                     	ext.celulas.splice(index,1);
	                     }

	                     scope.nuevaExtension = function(){
	                     	scope.item.resultado.extra.resultado.extensiones.push({ celulas : [{tipocelular:''}]});
	                     }

	                     scope.comprobarDiag = function(ext){
	                     	if(ext.tejido && ext.diagnostico){
	                     		//COMPROBAMOS SI TENEMOS QUE RELLENAR
	                     		//console.log(scope.centro);
								console.log("DIAGNOSTICO",ext.diagnostico);
	                     		ResultadosService.getDiagnosticoPlantilla(ext.tejido,ext.diagnostico,scope.centro.idioma_code,function(data){
	                     			if(data.plantilla){
	                     				ext = angular.merge(ext, data.plantilla);
	                     				scope.loadingFields = true;

	                     				$timeout(function(){

	                     				scope.loadingFields = false;
	                     				})
	                     			}
	                     			//console.log(data);
					               //scope.subanaliticas = data.subanaliticas;
					            });

	                     	}
	                     }

						 scope.comprobarBusq = function(ext){
							//console.log(nod);
						   console.log("EXT BUSQ", ext);
						   	if(ext.tejido && ext.busqueda){
								//COMPROBAMOS SI TENEMOS QUE RELLENAR
								ResultadosService.getDiagnosticoPlantilla(ext.tejido,ext.busqueda,scope.centro.idioma_code,function(data){
								   console.log("data receivced sadfasdf", data.plantilla.busqueda)
									if(data.plantilla){
										ext = angular.merge(ext, data.plantilla);
										ext.diagnostico = ext.busqueda;
										/*scope.loadingFields = true;
										$timeout(function(){

											scope.loadingFields = false;
										})*/
									}
							   });

							}
						}

	                     scope.optionsSelect2 = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            //nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

		            	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	scope.optionsTiposMuestra = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/tiposmuestra",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'tipomuestra',
		                            analitica_id:scope.item.analitica.id
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
	                	scope.optionsCelulas = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/celulas",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'tipomuestra',
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	function nucleo(el){
	                		
	                	}

	                	
	                	$(document).on('change.select2',".nucleo",function(){
							var valor = $(this).closest(".panel").find("select.nucleo option[value!='']:selected").map(function(){
			                  return $(this).text();
			                }).get();
	                		$(this).closest('.panel').find('.nucleodiv').text(valor.join(" / "));
			        	})

			        	$(document).on('change.select2',".citoplasma",function(){
			        		var valor = $(this).closest(".panel").find("select.citoplasma option[value!='']:selected").map(function(){
			                  return $(this).text();
			                }).get();
	                		$(this).closest('.panel').find('.citodiv').text(valor.join(" / "));
			        	})

			        	$(document).on('change.select2',".morfo",function(){
			        		var valor = $(this).closest(".panel").find("select.morfo option[value!='']:selected").map(function(){
			                  return $(this).text();
			                }).get();
	                		$(this).closest('.panel').find('.morfodiv').text(valor.join(" / "));
			        	})
	                });
		        }
          }
      }
})();